import React, { useContext } from "react";
import { CardItemAuthorization } from "../../../components/common/CardItemAuthorization";
import { DialogProviderAuthorization } from "../../../components/common/DialogProviderAuthorization";
import UserContext from "../../../context/user-context";
import useProviderAuthorization from "../../../hooks/useProviderAuthorization";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  markAuthorization,
  toggleAuthorization,
} from "../../../store/actions/userAction";
import { AuthorizationType, GuestType } from "../../../store/types/userTypes";
import { getResidentPassInformation } from "../../../utils/Parses";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";
import { CardAuthorization } from "../CardAuthorization/CardAuthorization";

type LastEntranceAuthorizationProps = {
  companion?: boolean,
};

export const LastEntranceAuthorization = ({
  companion,
}: LastEntranceAuthorizationProps) => {
  const { t, BundleKey } = useTranslation();
  const { state, dispatch } = useContext(UserContext);
  const { dialogState, checkProviderAuthorization, reset } =
    useProviderAuthorization();

  const handleCheckBoxChange = async (
    value: boolean,
    id: string,
    guestType: GuestType
  ) => {
    dispatch(markAuthorization(id, value, AuthorizationType.lastEntrance));
    if (value) {
      const pass = state.authorizations.find((pass) => pass.id === id);
      let host,
        lot = "";
      if (pass) {
        if (pass.authorization.host.customLot) lot = pass.id;
        else host = pass.authorization.host.id;
        await checkProviderAuthorization(pass.authorization.host, host, lot);
      }
    }
  };

  const handleToggleChange = (value: GuestType, id: string) => {
    dispatch(toggleAuthorization(id, value, AuthorizationType.lastEntrance));
  };

  return (
    <>
      {state.authorizations?.length !== 0 &&
      state.authorizations?.find(
        (item) => item.type === AuthorizationType.lastEntrance
      ) !== undefined ? (
        <CardAuthorization
          title={t(BundleKey.DETAIL_AUTHORIZATION_LAST_TITLE)}
          type={AuthorizationType.lastEntrance}
        >
          {state.authorizations.map((pass, index) => {
            if (pass.type === AuthorizationType.lastEntrance && !pass.hidden)
              return (
                <CardItemAuthorization
                  key={index}
                  id={pass.id}
                  tabIndex={
                    state.config?.companion
                      ? CompanionTabIndex.lastEntrance
                      : EntrantTabIndex.lastEntrance
                  }
                  checkValue={pass.mark}
                  checkHandle={handleCheckBoxChange}
                  toggleTypeValue={pass.guestType}
                  toggleTypeHandle={handleToggleChange}
                >
                  {getResidentPassInformation(
                    pass.authorization.host,
                    pass.authorization.beginDatetime,
                    pass.authorization.endDatetime,
                    pass.authorization
                  )}
                </CardItemAuthorization>
              );
          })}
        </CardAuthorization>
      ) : null}
      <DialogProviderAuthorization
        open={dialogState.open}
        close={reset}
        providers={dialogState.providers}
        lotName={dialogState.lotName}
      />
    </>
  );
};
